module.exports = __webpack_public_path__ + "img/bota.e259e89a.jpg";